import { render, staticRenderFns } from "./ContactUsCard.vue?vue&type=template&id=6f08d63f"
import script from "./ContactUsCard.vue?vue&type=script&lang=ts"
export * from "./ContactUsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports